// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2934":"e4916e96","3825":"e4916e96","6064":"b6470671","7748":"4f5106a5"}[chunkId] + ".chunk.css");